// extracted by mini-css-extract-plugin
module.exports = {"h5button":"gs","h5Button":"gs","button":"gt","block":"gu","btnDefault":"gv","disable":"gw","btnPrimary":"gx"};